<div
    class="agpr-tabs agpr-stepsNavigation"
    [ngClass]="{
        'agpr-tabsStretch': style === tabsStyleTypesEnum.icon
    }"
>
    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
    <ul
        *ngIf="tabs?.length > 0"
        class="agpr-tabs-tabsGroup"
        [ngClass]="{'agpr-tabs-tabsGroupStretch': style === tabsStyleTypesEnum.icon}"
        role="tablist"
        [attr.aria-orientation]="orientation"
        (keyup)="onKeyUp($event)"
    >
        <ng-container *ngFor="let tab of tabs; let last = last">
            <li
                [id]="tab.id"
                (click)="selectTab(tab)"
                role="tab"
                [attr.aria-controls]="tab.id + '.panel'"
                [attr.aria-selected]="tab.selected ? true : false"
                [attr.aria-label]="(tab.heading | localize) + '. ' + (tab.stateAriaLabel ? (tab.stateAriaLabel | localize) : '')"
                class="agpr-stepsNavigation-tabsContainer"
            >
                <div
                    class="agpr-tabs-tab agpr-tabs-distTab"
                    [ngClass]="{
                        'agpr-tabs-tab--selected': tab.selected,
                        'agpr-tabs-tab--disabled': tab.disabled,
                        'agpr-tabs-tabStretch': style === tabsStyleTypesEnum.icon
                    }"
                >
                    <ng-container *ngIf="tabTemplate">
                        <ng-container *ngTemplateOutlet="tabTemplate; context: {tab: tab}"></ng-container>
                    </ng-container>
                    <ng-container *ngIf="!tabTemplate">
                        <span
                            [id]="tab.id + '_tabIcon'"
                            class="agpr-stepsNavigation-tabIcon--notStarted fa-regular fa-duotone fa-circle"
                            [ngClass]="{
                                'agpr-stepsNavigation-tabIcon--selected fa-solid fa-pen-circle': tab.selected
                            }"
                            aria-hidden="true"
                        ></span>
                        <span
                            class="agpr-tabs-heading"
                            [ngClass]="{
                                'agpr-tabs-tabStretchHeading--selected': tab.selected,
                                'agpr-tabs-tabStretchHeading': style === tabsStyleTypesEnum.icon
                            }"
                            role="heading"
                            [attr.aria-level]="tabsHeadingLevel"
                        >
                            {{ tab.heading | localize }}
                        </span>
                    </ng-container>
                </div>
            </li>
            <li
                *ngIf="!last"
                class="agpr-stepsNavigation-tabsContainer agpr-stepsNavigation-arrowContainer"
            >
                <div
                    aria-hidden="true"
                    [id]="tab.id + '_arrowLine'"
                    class="agpr-stepsNavigation-arrow"
                >
                    <span #tabArrowLine class="agpr-stepsNavigation-arrowLine"></span>
                    <span class="agpr-stepsNavigation-arrowIcon fa-regular fa-angle-right"></span>
                </div>
            </li>
        </ng-container>
    </ul>
    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
    <ng-content select="[globalBanner]"></ng-content>
    <div
        *ngIf="(!tabs || tabs.length < 1 || _selectedTabIndex !== null) && useContentContainer"
        class="agpr-tabs-contents"
    >
        <div
            *ngIf="tabHeader"
            class="agpr-tabs-header"
        >
            <ng-container *ngTemplateOutlet="tabHeader"></ng-container>
        </div>
        <agpr-scroll-panel #scrollPanel>
            <ng-content></ng-content>
        </agpr-scroll-panel>
        <ng-content select="[noScrollPanelContent]"></ng-content>
    </div>
</div>
